import ProgressBar from "@ramonak/react-progress-bar";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchRpmActivityReport } from "../../../../../Redux/actions/rpmActions";
import dayjs from "dayjs";
import { APP_ROUTES } from "../../../../../PageRouting/approutes";

function Index() {
  const { rpmActivityReport, selectedRpmPatient } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const payload = {
      patientId: selectedRpmPatient?.patientId,
      hospitalId: selectedRpmPatient?.hospitalId,
      locationId: selectedRpmPatient?.locationId,
      providerCode: selectedRpmPatient?.providerCode,
      rpmApplicable: "Y",
      fromDate: dayjs(new Date()).format("MM/DD/YYYY"),
      toDate: dayjs(new Date()).format("MM/DD/YYYY"),
    };
    dispatch(fetchRpmActivityReport(payload));
  }, []);

  const handleNavigation = () => {
    history.push(APP_ROUTES.RPMACTIVITYREPORT);
  };

  return (
    <div>
      <div className="bg-white rounded-lg p-4 h-[190px] overflow-y-scroll scrollHide flex flex-col justify-between border">
        <div className="flex justify-between items-center pb-2">
          <div className="text-black xl:text-base text-sm font-sans font-bold">
            Activity Report
          </div>
          <button
            onClick={handleNavigation}
            className="cursor-pointer text-xs text-gray-500 hover:text-purple-600 hover:underline bg-white"
          >
            View All
          </button>
        </div>
        <div className="flex flex-col justify-between h-full">
          <div>
            <div className="flex justify-between text-xs xl:text-sm font-sans font-medium">
              <span>Vital</span>
              <span className="text-xs font-sans font-semibold">
                {rpmActivityReport?.vitalsEnteredCount} Days
              </span>
            </div>
            <div className="my-1">
              <ProgressBar
                completed={rpmActivityReport?.vitalsEnteredCount || 0}
                maxCompleted={20}
                height="10px"
                bgColor="#9421F3"
                baseBgColor="#E5E7EB"
                labelColor="#ffffff"
                labelSize="10px"
                customLabel={rpmActivityReport?.vitalsEnteredCount || 0}
              />
            </div>

            <div className="flex justify-between text-xs xl:text-sm font-sans font-medium">
              <span>Medicine</span>
              <span className="text-xs font-sans font-semibold">
                {rpmActivityReport?.medicationEnteredCount} Days
              </span>
            </div>
            <div className="my-1">
              <ProgressBar
                height="10px"
                bgColor="#FB7800"
                completed={rpmActivityReport?.medicationEnteredCount || 0}
                maxCompleted={20}
                labelSize="10px"
                customLabel={rpmActivityReport?.medicationEnteredCount || 0}
              />
            </div>

            <div className="flex justify-between text-xs xl:text-sm font-sans font-medium">
              <span>Tasks</span>
              <span className="text-xs font-sans font-semibold">
                {rpmActivityReport?.taskEnteredCount} Days
              </span>
            </div>
            <div className="my-1">
              <ProgressBar
                height="10px"
                bgColor="#FFB800"
                completed={rpmActivityReport?.taskEnteredCount || 0}
                maxCompleted={20}
                labelSize="10px"
                customLabel={rpmActivityReport?.taskEnteredCount || 0}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
